export class UserRequest {

    userID: string = "";
    accessID: number = 0;
    exclusiveFlag: boolean = false;

    constructor(userID: string, accessID: number, exclusiveFlag: boolean) {
        this.userID = userID;
        this.accessID = accessID;
        this.exclusiveFlag = exclusiveFlag;
    }
}